// extracted by mini-css-extract-plugin
export default {"home":"Collections_home__v++uD"};